import { render, staticRenderFns } from "./ExerciseInstructions.vue?vue&type=template&id=36ca97f7&scoped=true&"
import script from "./ExerciseInstructions.vue?vue&type=script&lang=js&"
export * from "./ExerciseInstructions.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseInstructions.vue?vue&type=style&index=0&id=36ca97f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ca97f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VDivider,VIcon,VTextarea})
